export default __webpack_public_path__ + "static/media/closet5-after1-1024w.95cef932.avif";